import SearchInput from '../../../components/ui/SearchInput';
import Select from '../../../components/ui/Select';
import type { AdminOrganizationFilters } from '../../../domain/superadmin/organizationFilters';
import {
    ORG_PLAN_FILTERS,
    ORG_SORT_FILTERS,
    ORG_STATUS_BUCKET_FILTERS,
} from '../../../domain/superadmin/organizationFilters';

type Props = {
    filters: AdminOrganizationFilters;
    search: string;
    onSearch: (value: string) => void;
    onChange: (patch: Partial<AdminOrganizationFilters>) => void;
};

const ALL = { value: '', label: 'Todos' };

function withAll(options: { value: string; label: string }[]): { value: string; label: string }[] {
    return [ALL, ...options];
}

export function OrganizationsFilters({ filters, search, onSearch, onChange }: Props) {
    return (
        <section
            aria-label="Filtros e busca"
            className="mb-s4 flex flex-col gap-s3 lg:flex-row lg:items-end"
        >
            <div className="grid flex-1 grid-cols-1 gap-s3 sm:grid-cols-3">
                <Select
                    label="Status"
                    selectSize="sm"
                    value={filters.statusBucket}
                    options={withAll(ORG_STATUS_BUCKET_FILTERS)}
                    onChange={(e) => onChange({ statusBucket: e.target.value })}
                />
                <Select
                    label="Plano"
                    selectSize="sm"
                    value={filters.plan}
                    options={withAll(ORG_PLAN_FILTERS)}
                    onChange={(e) => onChange({ plan: e.target.value })}
                />
                <Select
                    label="Ordenação"
                    selectSize="sm"
                    value={filters.sort}
                    options={ORG_SORT_FILTERS}
                    onChange={(e) => onChange({ sort: e.target.value })}
                />
            </div>

            <div className="w-full lg:w-72">
                <SearchInput
                    value={search}
                    onChange={onSearch}
                    placeholder="Nome, e-mail ou CNPJ"
                />
            </div>
        </section>
    );
}
